var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{class:_vm.classList},[_c('Notifications'),(_vm.isBrowseModeEnabled)?[_c('BrowseMode',{key:"browser"})]:[_c('Builder',{key:"builder"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }